export default function Go_Maps () {
  return (
    <div>
      <h1>Go_Maps </h1>
      <p>Go Maps</p>
    </div>
  );
}